import { render, staticRenderFns } from "./UserPayments.vue?vue&type=template&id=4ee0d02c"
import script from "./UserPayments.vue?vue&type=script&lang=js"
export * from "./UserPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports